var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24743 0.860086C5.64584 0.404759 6.35417 0.40476 6.75258 0.860087L11.5488 6.3415C12.1146 6.98808 11.6554 8 10.7962 8L1.20377 8C0.34461 8 -0.114568 6.98808 0.451192 6.34149L5.24743 0.860086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfoldIcon);
export default __webpack_public_path__ + "static/media/unfold-icon.93e5a35c7be487bbe9b66dfaaf15fe63.svg";
export { ForwardRef as ReactComponent };